import { Box, IconButton } from '@mui/material';
import { styled } from '@mui/material/styles';

export const ToggleButton = (props) => {
  const { isOpen, ...iconButtonProps } = props;
  return (
    <IconButton
      aria-label={isOpen ? 'Close menu' : 'Open menu'}
      aria-expanded={!!isOpen}
      size="small"
      sx={{ color: 'white', display: 'inline-flex' }}
      {...iconButtonProps}
    >
      <ToggleIcon active={isOpen} />
    </IconButton>
  );
};

const ToggleIcon = (props) => {
  const { active } = props;
  return (
    <Box
      component="span"
      aria-hidden
      sx={{
        display: 'block',
        width: '1.5rem',
        height: '1.5rem',
        position: 'relative',
        color: 'white',
        pointerEvents: 'none',
      }}
    >
      <Bar
        sx={{
          top: active ? '0.6875rem' : '0.4375rem',
          transform: active ? 'rotate(45deg)' : undefined,
        }}
      />
      <Bar
        sx={{
          bottom: active ? '0.6875rem' : '0.4375rem',
          transform: active ? 'rotate(-45deg)' : undefined,
        }}
      />
    </Box>
  );
};

const Bar = styled('span')({
  display: 'block',
  position: 'absolute',
  width: '1.25rem',
  height: '0.125rem',
  borderRadius: '9999px',
  backgroundColor: 'currentColor',
  margin: 'auto',
  left: '0.125rem',
  transition: 'all 0.12s',
});
